import React, { useState, useEffect } from "react";
import { Row, Col, Typography, Button } from "antd";
import { JIRA_AUTHORIZE } from "api/Jira";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import Card from "../Card";
import JiraLogo from "../../../common/assets/jiraIcon.png";
import styles from "../styles.module.css";
import ConnectModal from "components/Modals/ConnectModal";

const { Text } = Typography;

const Auth = ({ setAuthenticated }) => {
  const location = useLocation();
  const { id } = queryString.parse(location.search);
  const [connectModal, setConnectModal] = useState(false);

  const handleAuth = () => {
    window.location.href = JIRA_AUTHORIZE(id);
  };

  return (
    <Card title="Jira" style={{ height: "140px" }}>
      <Row>
        <Col md={2}>
          <img style={{ width: 50 }} src={JiraLogo} alt="gitHub" />
        </Col>
        <Col md={15}>
          <div style={{ width: "80%", margin: "auto" }}>
            <Text>
              Connect Jira and start, pause and stop trackable issues from your
              sprints.
            </Text>
          </div>
        </Col>
        <Col md={7}>
          <Button
            onClick={() =>
              setConnectModal({ label: "Jira Cloud", workspace: id })
            }
            type="primary"
            size="large"
            color="#029875"
            className={styles.connectBtn + " px-7 w-full"}
          >
            Connect
          </Button>
        </Col>
      </Row>
      {connectModal && (
        <ConnectModal
          visible={connectModal}
          setVisible={setConnectModal}
          callback={handleAuth}
          setAuthenticated={setAuthenticated}
        />
      )}
    </Card>
  );
};

export default Auth;
